"use client";
import { FC } from "react";
import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";

interface StockCardSkeletonProps {
  showLogo?: boolean;
}

export const StockCardSkeleton: FC<StockCardSkeletonProps> = ({
  showLogo = true,
}) => {
  if (!showLogo) {
    return (
      <div className="inline-flex w-full min-w-[156px] items-start justify-start rounded-[8px] border border-[#e5e5e5] bg-white p-3 md:min-w-[215px]">
        <div className="flex w-full flex-col gap-3">
          <div className="flex items-center justify-between gap-2">
            <BFLSkeleton width="70%" height={16} borderRadius={4} />
            <BFLSkeleton width={18} height={18} borderRadius={4} />
          </div>

          <div className="flex flex-col gap-1">
            <BFLSkeleton width="60%" height={16} borderRadius={4} />
            <BFLSkeleton width="80%" height={12} borderRadius={4} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="items-start w-full min-w-[156px] min-h-[143px] md:min-w-[215px] md:min-h-[171px] inline-flex justify-start rounded-[8px] border border-[#e5e5e5] bg-white p-3">
      <div className="flex w-full flex-col gap-3">
        <div className="flex w-full flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="block h-[42px] w-[42px] md:h-[60px] md:w-[60px]">
              <span className="hidden md:block">
                <BFLSkeleton width={60} height={60} borderRadius={9999} />
              </span>
              <span className="block md:hidden">
                <BFLSkeleton width={42} height={42} borderRadius={9999} />
              </span>
            </span>
            <BFLSkeleton width={18} height={18} borderRadius={4} />
          </div>
          <BFLSkeleton width="70%" height={16} borderRadius={4} />
        </div>

        <div className="flex flex-col gap-1">
          <BFLSkeleton width="60%" height={16} borderRadius={4} />
          <BFLSkeleton width="80%" height={12} borderRadius={4} />
        </div>
      </div>
    </div>
  );
};

export default StockCardSkeleton;
